import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "competition-standings" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import isNil from 'lodash/isNil'
import { PropType, computed } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { CompetitionIndividualStandingsSlip } from '@/store/modules/competition.types'
import { formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompetitionStandingsIndividual',
  props: {
  slip: {
    type: Object as PropType<CompetitionIndividualStandingsSlip | null>,
    default: null,
  },
},
  setup(__props) {

const props = __props

const bodyClassList = computed<string[]>((): string[] => [
  'competition-standings-body',
  `n-cols-${props.slip?.showBestScoreOnly ? 9 : 8}`,
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNil)(__props.slip) || _unref(isNil)(__props.slip.bowlers) || __props.slip.bowlers.length === 0)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          message: _ctx.$t('competition-standings.empty-results')
        }, null, 8, ["message"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(bodyClassList.value)
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-name')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-club')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-association')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-klass')), 1)
          ]),
          (__props.slip.showBestScoreOnly)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-score')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-handicap')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-strike-count')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-last-game-score')), 1)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-score')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-calculation')), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-last-game-score')), 1)
                ])
              ], 64)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slip.bowlers, (bowler, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("div", null, [
                (bowler.ruleScore.rank)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_unref(formatFloat)(bowler.ruleScore.rank, 0)), 1))
                  : (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(1 + index), 1))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.fullName)), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.membership.clubName)), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.membership.associationName)), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.klassName)), 1)
              ]),
              (__props.slip.showBestScoreOnly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(bowler.bestScore.total, 0)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(bowler.bestScore.handicap, 0)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(bowler.bestScore.strikeCount, 0)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(bowler.bestScore.lastGame, 0)), 1)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.ruleScore.total)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.ruleScore.calculation)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(bowler.ruleScore.lastGameScore)), 1)
                    ])
                  ], 64))
            ], 64))
          }), 128))
        ], 2))
  ]))
}
}

})